const jwt_claims = {
    title: 'JWT Personalizado',
    description: 'Personalize o token de acesso ou token de ID, fornecendo informações adicionais para sua aplicação.',
    access_token: {
        card_title: 'Token de acesso',
        card_description: 'O token de acesso é a credencial usada pelas APIs para autorizar solicitações, contendo apenas as reivindicações necessárias para decisões de acesso.',
    },
    user_jwt: {
        card_field: 'Token de acesso do usuário',
        card_description: 'Adicione dados específicos do usuário durante a emissão do token de acesso.',
        for: 'para usuário',
    },
    machine_to_machine_jwt: {
        card_field: 'Token de acesso de máquina para máquina',
        card_description: 'Adicione dados extras durante a emissão do token de máquina para máquina.',
        for: 'para M2M',
    },
    id_token: {
        card_title: 'Token de ID',
        card_description: 'O token de ID é uma afirmação de identidade recebida após o login, contendo reivindicações de identidade do usuário para o cliente usar para exibição ou criação de sessão.',
        card_field: 'Token de ID do usuário',
        card_field_description: "As reivindicações 'sub', 'email', 'phone', 'profile' e 'address' estão sempre disponíveis. Outras reivindicações devem ser habilitadas aqui primeiro. Em todos os casos, seu aplicativo deve solicitar os scopes correspondentes durante a integração para recebê-las.",
    },
    code_editor_title: 'Personalizar as reivindicações {{token}}',
    custom_jwt_create_button: 'Adicionar reivindicações personalizadas',
    custom_jwt_item: 'Reivindicações personalizadas {{for}}',
    delete_modal_title: 'Excluir reivindicações personalizadas',
    delete_modal_content: 'Tem certeza de que deseja excluir as reivindicações personalizadas?',
    clear: 'Limpar',
    cleared: 'Limpado',
    restore: 'Restaurar padrões',
    restored: 'Restaurado',
    data_source_tab: 'Fonte de dados',
    error_handling_tab: 'Tratamento de erros',
    test_tab: 'Contexto de teste',
    jwt_claims_description: 'As reivindicações padrão são automaticamente incluídas no JWT e não podem ser substituídas.',
    user_data: {
        title: 'Dados do usuário',
        subtitle: 'Use o parâmetro de entrada `context.user` para fornecer informações vitais do usuário.',
    },
    grant_data: {
        title: 'Dados da concessão',
        subtitle: 'Use o parâmetro de entrada `context.grant` para fornecer informações vitais da concessão, disponível apenas para troca de token.',
    },
    interaction_data: {
        title: 'Contexto de interação do usuário',
        subtitle: 'Use o parâmetro `context.interaction` para acessar os detalhes da interação do usuário na sessão de autenticação atual.',
    },
    application_data: {
        title: 'Contexto da aplicação',
        subtitle: 'Use o parâmetro de entrada `context.application` para fornecer as informações da aplicação associadas ao token.',
    },
    organization_data: {
        title: 'Contexto da organização',
        subtitle: 'Use o parâmetro de entrada `context.organization` para fornecer as informações da organização de destino, disponível apenas para tokens de organização.',
    },
    token_data: {
        title: 'Dados do token',
        subtitle: 'Use o parâmetro de entrada `token` para a carga útil do token de acesso atual. ',
    },
    api_context: {
        title: 'Contexto da API: controle de acesso',
        subtitle: 'Use o método `api.denyAccess` para rejeitar a solicitação de token.',
    },
    error_handling: {
        title: 'Tratamento de erros',
        subtitle: 'Controla se a emissão do token deve ser bloqueada quando o script falhar.',
        input_field_title: 'Comportamento da emissão do token em caso de erro no script',
        block_issuance_switch: 'Bloquear a emissão do token quando o script gerar erros',
        default_hint_create: 'Novos scripts de claims personalizados bloqueiam por padrão a emissão do token quando o script falha. Se a API já fornecer um valor, o valor salvo será usado.',
        default_hint_edit: 'Scripts de claims personalizados existentes sem essa configuração mantêm o comportamento legado com essa opção desativada até que você salve um valor explicitamente.',
        warning: 'Quando ativado, erros de execução do script rejeitam a solicitação de token com `invalid_request` (400) e um `error_description` localizado. Chamadas para `api.denyAccess` ainda retornam `access_denied`.',
    },
    fetch_external_data: {
        title: 'Buscar dados externos',
        subtitle: 'Incorpore dados de suas APIs externas diretamente nas reivindicações.',
        description: 'Use a função `fetch` para chamar suas APIs externas e incluir os dados em suas reivindicações personalizadas. Exemplo: ',
    },
    environment_variables: {
        title: 'Definir variáveis de ambiente',
        subtitle: 'Use variáveis de ambiente para armazenar informações confidenciais.',
        input_field_title: 'Adicionar variáveis de ambiente',
        sample_code: 'Acessando variáveis de ambiente no manipulador de reivindicações JWT personalizado. Exemplo: ',
    },
    jwt_claims_hint: 'Limite as reivindicações personalizadas a menos de 50KB. As reivindicações padrão do JWT são incluídas automaticamente no token e não podem ser substituídas.',
    tester: {
        subtitle: 'Ajuste o token simulado e os dados do usuário para testar.',
        run_button: 'Executar teste',
        result_title: 'Resultado do teste',
    },
    sandbox_warning: {
        title: 'Os scripts são executados com privilégios do servidor',
        description: 'No Logto auto-hospedado, este script é executado no mesmo ambiente que o próprio Logto: ele pode ler variáveis de ambiente do servidor e acessar serviços na sua rede interna. Não está em sandbox. Conceda acesso a esta página apenas a pessoas em quem você confiaria o acesso ao servidor.',
    },
    form_error: {
        invalid_json: 'Formato JSON inválido',
    },
};
export default Object.freeze(jwt_claims);
